import React, { useState, useEffect, useRef } from 'react';
import { Routes, Route, useParams, BrowserRouter, useSearchParams } from 'react-router-dom';

import axios from 'axios';

import TicketForm from './container/TicketForm';

// const axe = require("@axe-core/react");
// axe(React, ReactDOM, 1000);

//const URL = 'http://localhost:3000/tickets/creator';
const URL = 'https://www.meldooplus.de/api/v3/tickets/creator';

function App({ dataKey, dataId }) {
	return (
		<BrowserRouter>
			<Routes>
				<Route path="/ticketV3/:dataId/:dataKey" element={<ShowForm />} />
				<Route path="*" element={<ShowForm dataKey={dataKey} dataId={dataId} />} />
			</Routes>
		</BrowserRouter>
	);
}

function ShowForm({ dataKey, dataId }) {
	const [formData, setFormData] = useState();
	const [partsData, setPartsData] = useState();
	const [loading, setLoading] = useState(true);
	const [errorStatus, setErrorStatus] = useState(false);
	const params = useParams();
	const [queryParameters] = useSearchParams();
	const ErrorText = useRef('Formular nicht gefunden');

	const dataIdChecked =
		dataId ||
		queryParameters.get('dataId') ||
		(window.location.hostname === 'www.meldooplus.de' || window.location.hostname === 'localhost'
			? params.dataId
			: document.getElementById('meldooRoot').getAttribute('data-id'));
	const dataKeyChecked =
		dataKey ||
		queryParameters.get('dataKey') ||
		(window.location.hostname === 'www.meldooplus.de' || window.location.hostname === 'localhost'
			? params.dataKey
			: document.getElementById('meldooRoot').getAttribute('data-key'));

	useEffect(() => {
		const getData = async () => {
			try {
				const response = await axios.get(`${URL}/getform/${dataIdChecked}/${dataKeyChecked}`, {
					params: {},
					withCredentials: false,
					crossdomain: true
				});
				if (response?.data?.error) {
					ErrorText.current = response?.data?.error;
					setErrorStatus(true);
				}
				setFormData(response?.data?.form);
				setPartsData(response?.data?.parts);
				setLoading(false);
			} catch (error) {
				console.log(error);
				setLoading(false);
			}
		};
		getData();
	}, []);

	if (loading) return <div>Lade Daten...</div>;
	if (errorStatus) return <div className="App">{ErrorText.current}</div>;

	return (
		<div className="App" xmlns="meldooTicket">
			<TicketForm formData={formData} parts={partsData} url={URL} formKey={dataKeyChecked} formId={dataIdChecked} />
		</div>
	);
}

export default App;
